import {
  ICycleFormReduxState,
  IGetCycleFormAction,
  IGetCycleFormActionFulfilled,
  IGetCycleFormActionRejected,
  IUpdateCycleFormAction
} from "../../types";

const initialState: ICycleFormReduxState = {
  completed: false,
  cycle: null,
  error: null,
  pending: false,
  questionnaireTemplates: [],
  rejected: false
};

type Actions =
  | IGetCycleFormAction
  | IGetCycleFormActionFulfilled
  | IGetCycleFormActionRejected
  | IUpdateCycleFormAction;

export default (state = initialState, action: Actions): ICycleFormReduxState => {
  switch (action.type) {
    case "GET_CYCLE_FORM":
      return {
        ...state,
        completed: false,
        cycle: null,
        error: null,
        pending: true,
        questionnaireTemplates: [],
        rejected: false
      };
    case "GET_CYCLE_FORM_REJECTED":
      const { e } = action.payload;
      return {
        ...state,
        completed: true,
        cycle: null,
        error: e,
        pending: false,
        questionnaireTemplates: [],
        rejected: true
      };
    case "GET_CYCLE_FORM_FULFILLED":
      const { cycle, questionnaireTemplates } = action.payload;
      return {
        ...state,
        completed: true,
        cycle,
        error: null,
        pending: false,
        questionnaireTemplates,
        rejected: false
      };
    case "UPDATE_CYCLE_FORM":
      return {
        ...state,
        cycle: action.payload,
        error: null
      };
    default:
      return {
        ...state,
        error: null
      };
  }
};
